import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchVideos } from "../../features/videos/videosSlice";
import Loading from "../ui/Loading";
import VideoGridItem from "./VideoGridItem";

const VideoGrid = () => {
    const dispatch = useDispatch();
    const { videos, isLoading, isError, error } = useSelector(
        (state) => state.videos
    );
    const { tags, searchText, author, currentPage, videosPerPage } =
        useSelector((state) => state.filter);

    useEffect(() => {
        dispatch(
            fetchVideos({
                tags,
                searchText,
                author,
            })
        );
    }, [dispatch, tags, searchText, author, currentPage, videosPerPage]);

    //update title based on videos length , searches and filters
    if (videos.length > 0) {
        if (searchText.length > 0) {
            document.title = `(${videos.length}) ${searchText} - YouTube mini`;
        } else if (author.length > 0) {
            document.title = `(${videos.length}) ${author} - YouTube mini`;
        } else {
            document.title = `(${videos.length}) YouTube mini`;
        }
    } else {
        document.title = `(${videos.length}) YouTube mini`;
    }

    // Get current videos
    const indexOfLastVideo = currentPage * videosPerPage;
    const indexOfFirstVideo = indexOfLastVideo - videosPerPage;
    const currentVideos = videos?.slice(indexOfFirstVideo, indexOfLastVideo);

    //decide what to render
    let content;

    if (!isLoading && isError)
        content = (
            <div className="col-span-12 text-center text-red-400 text-xl font-medium">
                {error}
            </div>
        );

    if (!isLoading && !isError && videos.length === 0)
        content = (
            <div className="col-span-12 text-center">No videos found.</div>
        );

    if (!isLoading && !isError && videos.length > 0)
        content = currentVideos?.map((video) => (
            <VideoGridItem key={video.id} videoInfo={video} />
        ));

    return (
        <section className="pt-12">
            {isLoading ? (
                <div className="my-12 mx-auto w-20">
                    <Loading />
                </div>
            ) : (
                <div className="grid grid-cols-12 gap-4 max-w-7xl mx-auto px-5 lg:px-0 min-h-[300px]">
                    {content}
                </div>
            )}
        </section>
    );
};

export default VideoGrid;
